import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ planzone, runId }) =>
    present(
      repository
        .getExportBiRun(planzone, runId)
        .then((run) => ({ planzone, run }))
        .catch(() => Promise.reject({ planzone, runId })),
    );
}

export type { Interactor };

export { createInteractor };
